(function ($) {

    // N.B. cobrandPath and applicationPath are passed in as global variables

    var self = this || {};

    ssm.addState({
        id: "tablet",
        maxWidth: 1024,
        onLoad: function () {
            $(".pages a").on("click", self.nextPrevLoading);

        },
        onEnter: function () {
            $(".pages a").on("click", self.nextPrevLoading);

        },
        onLeave: function () {
            $(".pages a").off("click", self.nextPrevLoading);
        }
    });

    // set up state for mobile
    ssm.addState({
        id: "mobile",
        maxWidth: 600,

        onEnter: function () {

        },
        onLeave: function () {
            $.colorbox.close();
        }
    });

    ssm.addState({
        id: "wide",
        minWidth: 1640,
        onEnter: function () {
            $(".search-skyscraper").addClass("repositioned");
        },
        onLeave: function () {
            $(".search-skyscraper").removeClass("repositioned");
        }
    });

    self.categoryOverlayMouseout = true;

    $(function () {

        var observer = lozad('.lozad');
        observer.observe();

        $("input[name='TagIds']").change(function (e) {
            // unselect child tags when parent is deselected

            if (!this.checked) {
                $("#sub-tags-" + this.value + " input[type='checkbox']").prop("checked", false);
            }
            // select parent when child is selected

            if ((this.checked) && (this.hasAttribute('data-parent'))) {
                var parent = $(this).data('parent');
                $("input[type='checkbox'][value='" + parent + "']").prop("checked", true);
            }
        });

        // auto-submit when 'Age of Listing' and 'Type of Business' radio and checkboxes are clicked
        $("input[name='Age'], input[name='TagIds'], select[name='PageSize'], select[name='Sort']").change(function (e) {
            if (!$("#option-links-wrap").is(":visible")) {
                self.submitForm(this);
            }
        });

        // behaviour for price fields
        $(".financial-form li.button").hide();
        $(".financial-form input:button").click(function () { self.submitForm(this); });

        $(".financial-form").each(function (i, ol) {
            $("input:text", ol).keyup(function (e) {
                var c = $("input:checkbox", ol)[0];
                if (!c.altered) {
                    var fromto = $("input:text", ol);
                    c.checked = !(fromto[0].value == '' && fromto[1].value == '');
                }
                $("li.button", ol).show();
            });
            $("input:checkbox", ol).click(function (e) {
                this.altered = true;
                $("li.button", ol).show();
            });
        });

        $(".cancel-filter-option").click(function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $(".apply-filter-option").click(function (e) {
            e.preventDefault();

            // copy controls from colorbox back to form
            $.each($("div#colorbox :input").serializeArray(), function () {
                $("form[name='searchFilterForm']").append('<input type="hidden" name="' + this.name + '" value="' + this.value + '"/>');
            });

            self.submitForm();
        });

        $("#category-select-1, #category-select-2, #category-select-3").change(function (e) {
            self.updateCrumbtrail();
            $.post(cobrandPath + "search/updateCategories", $("form[name='searchFilterForm']").serialize(), function (data) {
                self.updateControls(data);
            });
        }).focus(function (e) {
            var column = parseInt(this.id.substring(16));

            // de-select higher columns
            for (var i = column + 1; i <= 3; i++)
                document.getElementById("category-select-" + i).selectedIndex = -1;
        });
        $("#category-trigger-1, #category-trigger-2, #category-trigger-3").click(function (e) { self.populateCategoryPickers(this); });
        $("#category-pickers-overlay, #category-select-1, #category-select-2, #category-select-3").blur(self.categoryPickersOverlayOnBlur);
        $("#category-pickers-overlay, #category-trigger-1, #category-trigger-2, #category-trigger-3").mouseover(function (e) { self.categoryOverlayMouseout = false; }).mouseout(function (e) { self.categoryOverlayMouseout = true; });
        $("#category-pickers-close").click(function (e) { self.hideOverlay('category-pickers-overlay'); self.restoreCategoryTierState(); });
        $("#category-pickers-button").click(function (e) { self.hideOverlay('category-pickers-overlay'); self.submitForm($('#category-pickers-overlay option:selected').last()[0]); });

        try {
            window.regionFilter1 = new LazyFilter('region-tier-1', 'region-suggest-1', 'region-container-1', 'region-trigger-1', 'region-close-1');
            window.regionFilter2 = new LazyFilter('region-tier-2', 'region-suggest-2', 'region-container-2', 'region-trigger-2', 'region-close-2');
            window.regionFilter3 = new LazyFilter('region-tier-3', 'region-suggest-3', 'region-container-3', 'region-trigger-3', 'region-close-3');
            window.regionFilter4 = new LazyFilter('region-tier-4', 'region-suggest-4', 'region-container-4', 'region-trigger-4', 'region-close-4');
        }
        catch (e) { }

        $("#filters-trigger").click(function (evt) {
            evt.preventDefault();
            window.location.hash = $(this).attr('id');
            $('.search-aside').show();
            $("body").addClass('box-open');
        });

        $("#sort-trigger").click(function (evt) {
            evt.preventDefault();
            $('.sort-results').slideToggle();
        });

        self.fixOwl = function () {

            var $stage = $('.owl-stage'),
                stageW = $stage.width(),
                $el = $('.owl-item'),
                elW = 0;
            $el.each(function () {
                elW += $(this).width() + +($(this).css("margin-right").slice(0, -2));
            });
            if (elW > stageW) {
                $stage.width(elW);
            };
        };


        $('.owl-carousel').owlCarousel({
            stagePadding: 10,
            margin: 5,
            autoWidth: true,
            nav: true,
            navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
            onInitialized: self.fixOwl,
            onRefreshed: self.fixOwl
        });

        $(document).on('click', 'a#close-filters', function (evt) {
            evt.preventDefault();
            $('.search-aside').hide();
        });

        $("#keywords")

            .autocomplete({
                source: function (request, response) {
                    $.post(cobrandPath + "search/suggest",
                        $("#keywords").serialize(),
                        function (data) { response(data); },
                        "json");
                }

            });

        // shortlist ajax functionality
        const $shortlistForm = $("#shortlist-form");
        const $advertId = $shortlistForm.find("input[name='advertId']");
        const $bookmark = $shortlistForm.find("input[name='bookmark']");

        $(document.body).on("click", "button[form='shortlist-form']", function (e) {
            e.preventDefault();

            const $button = $(this);
            const advertId = $button.attr("data-advert-id"); // keep values per request so overlapping clicks don't change which advert the error fallback submits
            const bookmark = $button.val();
            $advertId.val(advertId);
            $bookmark.val(bookmark);

            // perform ajax request, submit the form normally on error as user may need to log in or register
            $.ajax({
                url: $shortlistForm.attr("action"),
                type: 'POST',
                data: $shortlistForm.serializeArray(),
                cache: false,
                success: function (results) { // returns list of advertIDs in shortlist

                    // iterate through all shortlist buttons on page and update them depending on whether advert is in shortlist
                    $(".save-listing button").each(function () {
                        const $shortlistButton = $(this);
                        const buttonAdvertId = parseInt($shortlistButton.attr("data-advert-id"));

                        // check if id is in returned list
                        if ($.inArray(buttonAdvertId, results) >= 0) {
                            $shortlistButton.find('span').text("Saved");
                            $shortlistButton.find('.fa').removeClass("fa-bookmark-o").addClass("fa-bookmark");
                            $shortlistButton.val("false");
                        } else {
                            $shortlistButton.find('span').text("Save");
                            $shortlistButton.find('.fa').removeClass("fa-bookmark").addClass("fa-bookmark-o");
                            $shortlistButton.val("true");
                        }
                    });

                },
                error: function () {
                    // values set again just in case the user triggered a different request in the meantime
                    $advertId.val(advertId);
                    $bookmark.val(bookmark);
                    $shortlistForm[0].submit();
                }
            });
        });

        // saved search and email alerts functionality
        $(document.body).on("submit", "#save-search-form", function (e) {
            e.preventDefault();
            var form = $(this);

            // perform ajax request, submit the form normally on error as user may need to log in or register
            $.ajax({
                url: form.attr("action"),
                type: 'POST',
                data: form.serialize(),
                cache: false,
                success: function (data) { // returns html
                    var alertControl = $("#ea-link-wrap");
                    var response = $(data);
                    alertControl.replaceWith(response.find("#ea-link-wrap"));
                    response.filter("script").appendTo(document.body);
                },
                error: function () { form[0].submit(); }
            });
        });

    });


    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
        // Start with the original label text.
        let newLabel = item.label;

        // Get an array of the words in the search term, filtering out any empty strings.
        // This handles multiple spaces between words.
        const searchWords = this.term.split(/\s+/).filter(word => word.length > 0).sort((a, b) => b.length - a.length);

        // If there are search terms, build a regex to find and replace them.
        if (searchWords.length) {
            // Create a regular expression that looks for any of the search words.
            // \b: ensures we match the beginning of words only.
            // gi: g ensures all occurrences are replaced, i makes it case-insensitive.
            const regex = new RegExp('\\b(' + searchWords.join('|') + ')', 'gi');

            // Replace the matched words with a span-wrapped version.
            // The '$1' in the replacement string refers to the matched word,
            // preserving its original casing from the item label.
            newLabel = newLabel.replace(regex, '<span class="matched">$1</span>');
        }

        // Create the list item, append the newly formatted label, and add it to the list.
        return $("<li></li>")
            .data("item.autocomplete", item)
            .append('<a>' + newLabel + '</a>')
            .appendTo(ul);
    };


    self.submitting = false;
    self.submitForm = function (input) {
        if (!self.submitting) {
            self.submitting = true;

            // get data-url from selected option or element itself
            var url = ($(input).find("option:selected")[0] || input).getAttribute("data-url");

            // strip off querystring
            var query = [];
            var qPos = url.indexOf('?');
            if (qPos > 0) {
                query = url.substring(qPos + 1).split('&');
                url = url.substring(0, qPos);
            }

            var financials = [];

            $("#desktop-form .financial-form input").each(function (i, el) {
                var name = el.name;

                // strip out querystring values matching financial fields
                query = $.grep(query, function (item) { return item.substring(0, name.length + 1) != name + '='; });

                // append non-default financial fields
                var serializedValue = $(el).val() ? $(el).serialize() : null;
                if (serializedValue)
                    financials.push(serializedValue);
            });

            query = financials.concat(query);

            window.location = url + (query.length ? '?' + query.join('&') : '');

            $("input[type='checkbox'], input[type='radio']").each(function () {
                this.disabled = true;
            });
        }
    };

    self.resizeTimer = 0;
    self.resizeColorBox = function () {
        if (self.resizeTimer) clearTimeout(self.resizeTimer);
        self.resizeTimer = setTimeout(function () {

            if (($('#cboxOverlay').is(':visible')) && (ssm.isActive('tablet'))) {
                $.colorbox.resize({ width: '100%', height: '100%' });
            }
        }, 300);
    };

    // Resize Colorbox when resizing window or changing mobile device orientation
    $(window).resize(self.resizeColorBox);
    window.addEventListener("orientationchange", self.resizeColorBox, false);

    self.updateControls = function (controlsEl) {
        var controls = controlsEl.getElementsByTagName('select');
        for (var i = 0; i < controls.length; i++)
            self.updateOptions(controls[i]);
    };

    self.updateOptions = function (controlEl) {
        var control = document.getElementsByName(controlEl.getAttribute("name"))[0];

        var slaveOptions = self.createOptions(controlEl);

        var selectedOptions = [];

        // preserve selected options if possible
        for (var i = 0; i < control.options.length; i++) {
            if (control.options[i].selected) {
                selectedOptions.push(control.options[i].value);
            }
        }

        control.length = 0;
        var optionsObj = control.options;
        for (var i = 0; i < slaveOptions.length; i++) {
            for (var j = 0; j < selectedOptions.length; j++) {
                if (slaveOptions[i].value == selectedOptions[j]) {
                    slaveOptions[i].selected = true;
                }
            }
            optionsObj.add(slaveOptions[i]);
        }
    };

    self.createOptions = function (controlEl) {
        var newOptions = [];
        var options = controlEl.getElementsByTagName("option");
        for (var i = 0; i < options.length; i++) {
            var text = self.getElementContent(options[i]);
            var value = options[i].getAttribute("value");
            var option = new Option(text, value);
            option.setAttribute("data-url", options[i].getAttribute("data-url"));
            newOptions.push(option);
        }
        return newOptions;
    };

    self.getElementContent = function (element) {
        return element.text != undefined ? element.text : element.textContent;
    };

    self.overlayPanel = function (f, imagePath, overlayClassName, centreImage) {
        var overlay = document.createElement("div");
        overlay.id = f.id + '-overlay';
        overlay.className = overlayClassName;

        var width = f.offsetWidth;
        var height = f.offsetHeight;

        var image = document.createElement("img");
        image.src = imagePath;

        var pos = $(f).position();
        overlay.style.top = pos.top + "px";
        overlay.style.left = pos.left + "px";
        overlay.style.width = width + "px";
        overlay.style.height = height + "px";

        if (centreImage) {
            image.style.top = Math.round(height / 4) + "px";
        }

        f.parentNode.appendChild(overlay);
        overlay.style.zIndex = 201;
        overlay.appendChild(image);
    };

    self.populateCategoryPickers = function (trigger) {
        var overlay = document.getElementById('category-pickers-overlay');

        if (overlay.style.display == 'none') {
            self.backupCategoryTierState();

            var column = parseInt(trigger.id.substring(17));

            // remove options for higher columns
            for (var i = column + 1; i <= 3; i++)
                document.getElementById("category-select-" + i).length = 0;

            self.overlayPanel(trigger, applicationPath + "Content/Shared/images/ajax-loader.gif", "trigger-loading");

            $.post(cobrandPath + "search/updateCategories", $("form[name='searchFilterForm']").serialize(), function (data) {
                self.updateControls(data);
                self.updateCrumbtrail();
                $("#category-trigger-1-overlay, #category-trigger-2-overlay, #category-trigger-3-overlay").remove();
                self.showOverlay('category-trigger-1', 'category-pickers-overlay');
            });

        } else {
            overlay.style.display = 'none';
        }
    };

    self.categoryPickersOverlayOnBlur = function () {
        if (self.categoryOverlayMouseout == true) {
            self.hideOverlay('category-pickers-overlay');
            self.restoreCategoryTierState();
        }
    };

    self.categoryTierState = [];

    self.backupCategoryTierState = function () {
        for (var i = 1; i <= 3; i++) {
            var control = document.getElementById("category-select-" + i);
            self.categoryTierState[i] = control.selectedIndex > -1 ? control.options[control.selectedIndex] : null;
        }
    };

    self.restoreCategoryTierState = function () {
        for (var i = 1; i <= 3; i++) {
            var control = document.getElementById("category-select-" + i);
            control.length = 0;
            var option = self.categoryTierState[i];
            if (option != null)
                control.options.add(option);
        }
    };

    self.getCrumbtrail = function () {
        var s = '';
        var t;

        for (var i = 3; i >= 1; i--) {
            var control = document.getElementById("category-select-" + i);

            if (control.selectedIndex > -1) {
                t = control.options[control.selectedIndex].text;

                s = $.trim(t.replace(/>/, '')) + s;

                if (i > 1) {
                    s = ' > ' + s;
                }
            }
        }

        return s;
    };

    self.updateCrumbtrail = function () {
        var crumbtrailDiv = document.getElementById('category-pickers-crumbtrail');
        if (crumbtrailDiv) {
            crumbtrailDiv.innerHTML = self.getCrumbtrail();
        }
    };

    self.showOverlay = function (triggerId, overlayId) {
        var overlay = document.getElementById(overlayId);
        var trigger = document.getElementById(triggerId);

        if (overlay.style.display == 'none') {

            var overlayParent = overlay.parentNode;
            var overlayParentPos = $(overlayParent).offset();
            var triggerPos = $(trigger).offset();

            overlay.style.top = triggerPos.top - overlayParentPos.top + trigger.offsetHeight + 'px';
            overlay.style.display = '';

            overlay.focus();

        } else {
            overlay.style.display = 'none';
        }
    };

    self.hideOverlay = function (overlayId) {
        document.getElementById(overlayId).style.display = 'none';
    };

    window.LazyFilter_onSeeMore = function (f) {
        self.overlayPanel(f.suggestionsDiv, applicationPath + "Content/Shared/images/ajax-loader-large.gif", "lazy-filter-loading", true);
    };

    window.LazyFilter_onFocus = function (f) {
        var column = f.id.substring(12);
        var query = '&column=' + column + '&query=' + f.lastRequestString;
        if (f.showAll)
            query += '&showAll=1';

        self.overlayPanel(f.trigger, applicationPath + "Content/Shared/images/ajax-loader.gif", "trigger-loading", false);

        $.post(cobrandPath + "search/updateRegions", $("form[name='searchFilterForm']").serialize() + query, function (data) {
            self.updateControls(data);
            $("#" + f.trigger.id + "-overlay").remove();
            $("#" + f.id + "-suggestions-overlay").remove();
            f.update();
        });
    };

    window.LazyFilter_onClick = function (f) {
        self.submitForm($(f.select).closest("li").prevAll().addBack().find("option:selected").filter(function (i, el) { return $(el).val() != ''; }).last()[0]);
    };

    $(document).on('cbox_open', function () {
        $("body").addClass('box-open');
    }).on('cbox_closed', function () {
        $("body").removeClass('box-open');
    });

    window.hideNotification = function () {
        $("body").addClass('snack-notification-inactive');
        $('.snack-notification').addClass('remove-notification')
            .one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
                $(this).hide().removeClass('remove-notification');
                $("body").removeClass('snack-notification-active').removeClass('snack-notification-inactive');
            });
    };

    self.nextPrevLoading = function () {
        $(".next-link a, .prev-link a").addClass("clicked");
    };

})(jQuery);